<template>
  <div id="contenedor-print">
    <table>
      <thead>
        <tr>
          <td>
            <div class="header-spacer">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <slot name="contenido"></slot>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="footer-spacer">&nbsp;</div>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="header">
      <div class="contenido-header">
        <slot name="header"></slot>
      </div>
    </div>
    <div class="footer">
      <div class="contenido-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'printContenido',
  data: () => ({}),
};
</script>

<style lang="scss" scoped>
#contenedor-print {
  display: none;
}
.header,
.header-spacer,
.footer,
.footer-spacer {
  height: 100px;
}
.header,
.footer {
  position: fixed;
  width: 100%;
}

.header {
  top: 0;
}

.footer {
  bottom: 0;
}
.contenido-header,
.contenido-footer {
  position: relative;
  width: 100%;
  height: 100%;
}

@media print {
  #contenedor-print {
    display: block;
  }
}
</style>
